import {BaseContainerModel} from '../base-container.model';
import {bl_fi_mst_comp_RowCLass} from '../../dbschema/bl_fi_mst_comp.model';
import {bl_fi_mst_comp_ext_RowClass} from '../../dbschema/bl_fi_mst_comp_ext.model';

export class CompanyContainerModel extends BaseContainerModel {
  bl_fi_mst_comp: bl_fi_mst_comp_RowCLass = new bl_fi_mst_comp_RowCLass();
  bl_fi_mst_comp_ext: bl_fi_mst_comp_ext_RowClass[] = [];
}
